import React from 'react';
import {
  DetailWrapper,
  DetailIcon,
  DetailContent,
  DetailLabel,
  DetailValue
} from './index.style';

interface DetailFieldProps {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
}

const DetailField: React.FC<DetailFieldProps> = ({ label, value, icon }) => {
  return (
    <DetailWrapper>
      {icon ? <DetailIcon>{icon}</DetailIcon> : null}
      <DetailContent>
        <DetailLabel>{label}</DetailLabel>
        <DetailValue>{value}</DetailValue>
      </DetailContent>
    </DetailWrapper>
  );
};

export default DetailField;
